import * as React from "react";

import { getRoutePath, redirectToRoutePath, sectionClasses } from "../common/Utils";
import { QuoteFormEventType } from "../../../Common/QuoteFormEventTracking/QuoteFormEventType";
import { WizardStep } from "../common/WizardStep";

import { IStepProps } from "../interfaces/IStepProps";
import { IStepState } from "../interfaces/IStepState";
import { IAutoWizardModel } from "../interfaces/IAutoWizardModel";

import { LogStep } from "../../../Common/QuoteFormEventTracking/LogStep";

export class InsuranceCarrierStep extends React.Component<IStepProps, IStepState> {

    state: IStepState;

    constructor(props: IStepProps) {
        super(props);

        this.handleOnClick = this.handleOnClick.bind(this);

        this.state = {
            redirectPath: "",
            goToNextStep: false
        }
    }
    
    handleOnClick(event: React.MouseEvent<HTMLAnchorElement>): void {
        const valueElement = event.target as HTMLAnchorElement;
        const value = valueElement.dataset["value"];

        const model: IAutoWizardModel = JSON.parse(JSON.stringify(this.props.model));
        let nextStep: WizardStep = WizardStep.INSURED_SINCE;

        if (value === "0") {
            model.currentInsurance.currentlyInsured = "False";
            nextStep = WizardStep.GENDER;
        } else {
            model.currentInsurance.currentlyInsured = "True";
            model.currentInsurance.insuranceCarrier = value;
        }

        this.props.onUpdateModel(model);

        const routePath = getRoutePath(nextStep);

        this.setState({ redirectPath: routePath, goToNextStep: true });
    }

    getSelectedClass(optionValue: string): string {
        if (optionValue === "0" && this.props.model.currentInsurance.currentlyInsured === "False") {
            return "selected";
        } else if (optionValue === this.props.model.currentInsurance.insuranceCarrier) {
            return "selected";
        }

        return "";
    }

    render(): JSX.Element {
        if (this.state.goToNextStep) {
            redirectToRoutePath(this.state.redirectPath);
            return null;
        }

        const sectionStyle = {
            display: 'block'
        }

        return <React.Fragment>
            <LogStep lastStep="AdditionalVehicleModel" nextStep="InsuredSince" stepNumber={QuoteFormEventType.CurrentInsuranceStep} sectionName="InsuranceCarrier" wizardName="AutoWizard" logStep={true}/>
            <div id="InsuranceCarrierStep" className={sectionClasses} style={sectionStyle}>
                <h3>Current or Last Auto Insurance Provider</h3>
                <div id="InsuranceCarrier">
                    <div className="touch-list twoColumn">
                        <div className="touch-list-option"><a className={this.getSelectedClass("Other / My Company Is Not Listed")} onClick={this.handleOnClick} id="insurance_Other" data-value="Other / My Company Is Not Listed">Other / My Company Is Not Listed</a></div>
                        <div className="touch-list-option"><a className={this.getSelectedClass("Allstate Insurance")} onClick={this.handleOnClick} id="insurance_Allstate" data-value="Allstate Insurance">Allstate</a></div>
                        <div className="touch-list-option"><a className={this.getSelectedClass("Esurance")} onClick={this.handleOnClick} id="insurance_Esurance" data-value="Esurance">Esurance</a></div>
                        <div className="touch-list-option"><a className={this.getSelectedClass("Farmers Insurance")} onClick={this.handleOnClick} id="insurance_Farmers" data-value="Farmers Insurance">Farmers</a></div>
                        <div className="touch-list-option"><a className={this.getSelectedClass("Geico General Insurance")} onClick={this.handleOnClick} id="insurance_GeicoGeneral" data-value="Geico General Insurance">Geico</a></div>
                        <div className="touch-list-option"><a className={this.getSelectedClass("Liberty Mutual Insurance")} onClick={this.handleOnClick} id="insurance_LibertyMutual" data-value="Liberty Mutual Insurance">Liberty Mutual</a></div>
                        <div className="touch-list-option"><a className={this.getSelectedClass("Nationwide Insurance")} onClick={this.handleOnClick} id="insurance_Nationwide" data-value="Nationwide Insurance">Nationwide</a></div>
                        <div className="touch-list-option"><a className={this.getSelectedClass("Progressive")} onClick={this.handleOnClick} id="insurance_Progressive" data-value="Progressive">Progressive</a></div>
                        <div className="touch-list-option"><a className={this.getSelectedClass("State Farm Insurance")} onClick={this.handleOnClick} id="insurance_StateFarm" data-value="State Farm Insurance">State Farm</a></div>
                        <div className="touch-list-option"><a className={this.getSelectedClass("AAA Insurance")} onClick={this.handleOnClick} id="insurance_AAA" data-value="AAA Insurance">AAA Insurance</a></div>
                        <div className="touch-list-option"><a className={this.getSelectedClass("Farm Bureau Insurance")} onClick={this.handleOnClick} id="insurance_FarmBureau" data-value="Farm Bureau Insurance">Farm Bureau</a></div>
                        <div className="touch-list-option"><a className={this.getSelectedClass("United Services Automobile Association")} onClick={this.handleOnClick} id="insurance_UnitedServices" data-value="United Services Automobile Association">USAA</a></div>
                        <div className="touch-list-option"><a className={this.getSelectedClass("0")} onClick={this.handleOnClick} id="insurance_Uninsured" data-value="0">Uninsured</a></div>
                    </div>
                </div>
            </div>
        </React.Fragment>;
    }
}